import { render, staticRenderFns } from "./RegisterLitterForm2.vue?vue&type=template&id=543f14fe"
import script from "./RegisterLitterForm2.vue?vue&type=script&lang=ts"
export * from "./RegisterLitterForm2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_css-loader@6.11.0_webpack@5.110.0_clean-css_59f27df46aa4ef52cba8745f325ade8b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports